import React, { useState } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Header from './Header';
import Sidebar from './Sidebar';

const Layout = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-container">
      {/* Mobile sidebar */}
      <div className={`mobile-sidebar ${sidebarOpen ? 'open' : ''}`}>
        {sidebarOpen && (
          <div className="mobile-sidebar-overlay" onClick={() => setSidebarOpen(false)}>
            <div className="mobile-sidebar-content" onClick={(e) => e.stopPropagation()}>
              <button 
                className="mobile-sidebar-close"
                onClick={() => setSidebarOpen(false)}
              >
                &times;
              </button>
              <Sidebar mobile />
            </div>
          </div>
        )}
      </div>

      {/* Static sidebar for desktop */}
      <div className="desktop-sidebar">
        <Sidebar />
      </div>

      {/* Main content */}
      <div className="main-content">
        <Header setSidebarOpen={setSidebarOpen} />
        <main className="content-area">
          <div className="content-container">
            {children}
          </div>
        </main>
      </div>

      {/* Toast notifications */}
      <ToastContainer
        position="top-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
    </div>
  );
};

export default Layout; 